"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styled_components_1 = require("styled-components");
const theme_provider_1 = require("../theme-provider");
const radius = 7; // in a 24x24 svg viewbox
const circumference = 2 * Math.PI * radius;
const spin = styled_components_1.keyframes `
	to {
		transform: rotate(2turn);
	}
`;
const growth = styled_components_1.keyframes `
	0% {
		stroke-dashoffset: ${circumference};
	}
	50% {
		stroke-dashoffset: ${circumference / 4};
	}
	100% {
		stroke-dashoffset: ${circumference};
	}
`;
const StyledSpinner = theme_provider_1.styled.svg.withConfig({ displayName: "StyledSpinner", componentId: "sc-1vwt1hz" }) `
	${props => props.variant === 'default' &&
    theme_provider_1.css `
			width: ${props.theme.size.static350};
			height: ${props.theme.size.static350};
			stroke-width: ${props => `${(100 / parseInt(props.theme.size.static350, 10)) * 2}%`};
		`}
	${props => props.variant === 'large' &&
    theme_provider_1.css `
			width: ${props.theme.size.static510};
			height: ${props.theme.size.static510};
			stroke-width: ${props => `${(100 / parseInt(props.theme.size.static510, 10)) * 2}%`};
		`}
	${props => props.variant === 'x-large' &&
    theme_provider_1.css `
			width: ${props.theme.size.static625};
			height: ${props.theme.size.static625};
			stroke-width: ${props => `${(100 / parseInt(props.theme.size.static625, 10)) * 2}%`};
		`}
`;
const BackgroundPath = theme_provider_1.styled.path.withConfig({ displayName: "BackgroundPath", componentId: "sc-lgh2yp" }) `
	stroke: ${props => props.theme.interaction.recipe370.disabled};
`;
const ForegroundPath = theme_provider_1.styled.path.withConfig({ displayName: "ForegroundPath", componentId: "sc-sqxtmi" }) `
	stroke: ${props => props.theme.interaction.recipe370.default};
	stroke-dasharray: ${circumference} ${circumference};
	transform-origin: center;

	animation: 2s cubic-bezier(0.41, 0.2, 0.16, 0.59) ${spin} infinite,
		2s cubic-bezier(0.63, 0, 0.58, 1) ${growth} infinite;
`;
const circlePathData = 'M12,5a7,7 0 1,0 0,14a7,7 0 1,0 0,-14';
exports.Spinner = props => (React.createElement(StyledSpinner, { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", fill: "none", viewBox: "0 0 24 24", variant: props.variant || 'default' },
    React.createElement(BackgroundPath, { d: circlePathData }),
    React.createElement(ForegroundPath, { d: circlePathData })));
